import { Col, FormGroup, Input, Row } from 'reactstrap';
import SectionTitle from './SectionTitle';

interface Props {
  availableAt: string;
  setAvailableAt: (value: string) => void;
}

const SalesAvailabilityFields = ({ availableAt, setAvailableAt }: Props) => (
  <>
    <SectionTitle
      className="mt-2"
      title="Disponibilidad"
      hint='Es la fecha que se muestra en la ficha de la web como "Te puedes mudar".'
    />
    <Row>
      <Col lg="3" md="6">
        <FormGroup className="mb-3">
          <label className="form-control-label" htmlFor="available_at">
            ¿Desde cuándo está disponible?
          </label>
          <Input
            id="available_at"
            type="date"
            className="text-dark"
            value={availableAt}
            onChange={(e) => setAvailableAt(e.target.value)}
          />
        </FormGroup>
      </Col>
    </Row>
  </>
);

export default SalesAvailabilityFields;
